
import Code_Reduction from "../Code_Reduction/Code_Reduction.class";
import UserService from "../../services/user.service";

/**
 * @classdesc Une command inscription associé à une commande
 * @kind class
 * @export
 * @class MyClass
 */
export default class Commande_Inscription {
    id;
    id_commande;
    id_item;
    id_tarif;
    prix = 0;
    inscriptions = [];
    list_commandes_options = [];
    type;
    valide = false;
    pointe = false;
    gia;
    alerte_sms;
    plan_entrainement;
    code_reduction;


    /**
     * Creates an instance of Commande_Inscription.
     * @constructs
     * @kind function
     * @memberof Commande_Inscription
     */
    constructor() { }

    async get() {
        let res = await UserService.getCommandeInscription(this.id);
        if (res) { this.set(res); }
        return res;
    }

    async fetch() {
        let res = await UserService.getCommandeInscription(this.id);
        if (res) { this.set(res); }
        return res;
    }

    set(data) {
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
    }

    compute_reduction() {
        if (this.code_reduction && this.code_reduction.valide == '1' && this.code_reduction.code_promo_model) {
            let code_promo_model = new Code_Reduction();
            code_promo_model.set(this.code_reduction.code_promo_model);
            this.prix = code_promo_model.calcul_reduction(this.prix, "course");
        }
    }

    is_not_deleted_or_transfered() {
        for (let i = 0; i < this.inscriptions.length; i++) {
            if (this.inscriptions[i].supprime == 0 && this.inscriptions[i].transfere == 0) {
                return true;
            }
        }
        return false;
    }

    get_entete() {
        if (!this.inscriptions || !this.inscriptions[0]) return "";
        return this.inscriptions[0].nom + " " + this.inscriptions[0].prenom + " - " + this.inscriptions[0].course.nom;
    }


}